import { Box } from "@twilio-paste/core/box";
import { css, styled } from "@twilio-paste/styling-library";

export const HeadingContainer = styled(Box)(() =>
    css({
        gridArea: "heading",
        paddingX: ["space0", "space0", "space200"],
        overflow: "auto"
    })
);
